<script lang="ts">
	import '../app.css';
	import GA from '$lib/ga.svelte';
	import { afterNavigate, beforeNavigate } from '$app/navigation';
	import { initAndTrackNextdoorPageView } from '$lib/utils/nextdoor';
	import HeaderHeight from '$lib/layout/headerHeight.svelte';
	import EmailCapture from './emailCapture.svelte';
	import Friendbuy from './friendbuy.svelte';
	import GlobalSiteBanner from '$lib/storyblok/components/globalSiteBanner.svelte';
	import FriendbuyBanner from '$lib/banner/friendbuyBanner.svelte';
	import ShoppingCart from '$lib/storyblok/components/shoppingCart.svelte';
	import { friendbuy } from '$lib/state/friendbuy.svelte';

	let { children } = $props();

	// @see https://github.com/sveltejs/kit/pull/8724#issuecomment-1424436745
	let scrollBehavior: string;

	beforeNavigate(() => {
		scrollBehavior = getComputedStyle(document.documentElement).scrollBehavior;
		document.documentElement.style.scrollBehavior = 'auto';
	});

	afterNavigate(({ from, to }) => {
		if (scrollBehavior) {
			document.documentElement.style.scrollBehavior = scrollBehavior;
		}

		// MAR-798 - /order/success is handled on page level
		if (from?.route.id !== to?.route.id && !to?.route.id?.startsWith('/order/')) {
			initAndTrackNextdoorPageView();
		}
	});

	let bannerHeight = $state(0);
</script>

<GA />

<GlobalSiteBanner />
<HeaderHeight />

<div
	class="antialiased transition-padding duration-400"
	style=" --banner-height: {bannerHeight}px; padding-top: var(--banner-height)"
>
	{@render children?.()}
</div>

<EmailCapture />
<Friendbuy />

<div
	bind:clientHeight={bannerHeight}
	id="site-banner"
	class="fixed inset-x-0 top-0 z-[55] w-full empty:hidden"
>
	{#if friendbuy.show}
		<FriendbuyBanner />
	{/if}
</div>

<ShoppingCart />

<style lang="scss">
	div.antialiased {
		--full-header-height: calc(var(--header-height) + var(--banner-height));
	}
</style>
